export const CONNECT_GAME_ERRORS = {
  LIMIT_REACHED: 'game-limit-reached',
} as const;
